module.exports = "/static/media/screen_icon.ca257f4b.svg";